{
  "auth": {
    "agree": "Acepto",
    "error": "Se produjo un error al actualizar los datos, verifica tus datos e intenta nuevamente",
    "createAccount": "Crear una cuenta",
    "continue": "Continuar",
    "createNewAccount": "Crear cuenta nueva",
    "email": "Correo",
    "login": "Iniciar sesión",
    "password": "Contraseña",
    "recover_password": "¿Has olvidado tu contraseña?",
    "sign_up": "Registro de usuario",
    "sign_up_title": "Crea tu cuenta",
    "sign_up_subtitle": "Y empieza a organizar tus finanzas de manera inteligente.",
    "register_title": "Completa tu registro",
    "register_description": "¡Ya casi! Completa la información para tu nueva cuenta asociada a:",
    "keep_logged_in": "Mantenerme conectado",
    "termsOfUse": "Acepto términos y condiciones",
    "reset_password": "Restablecer contraseña",
    "dontHaveAccount": "¿No tienes una cuenta?",
    "loginWithGoogle": "Gmail",
    "loginWithFacebook": "Facebook",
    "haveAccount": "¿Ya tienes una cuenta?",
    "recoverSended": "Si existe una cuenta con ese correo electrónico, recibirás un enlace para restablecer tu contraseña.",
    "operation-not-allowed": "Inicio de sesión no permitido",
    "link": "y condiciones.",
    "next": "Siguiente",
    "emailOrPhone": "Correo o celular",
    "scanQR": "Escanea o haz clic en el código QR para completar la sincronización.",
    "finishRegister": "Finalizar registro",
    "passwordReq": {
      "len": "Mínimo 8 caracteres",
      "letter": "Una letra",
      "number": "Un número",
      "special": "Un carácter especial"
    }
  },
  "404": {
    "title": "Esta página se ha ido a pescar",
    "text": "Si crees que esto no es correcto, por favor envíanos un mensaje a ",
    "back_button": "Volver al inicio"
  },
  "typography": {
    "primary": "Estilos de texto primarios",
    "secondary": "Estilos de texto secundarios"
  },
  "dashboard": {
    "versions": "Versiones",
    "setupRemoteConnections": "Configurar conexiones remotas",
    "currentVisitors": "Visitantes actuales",
    "charts": {
      "trendyTrends": "Tendencias modernas",
      "showInMoreDetail": "Mostrar en más detalle",
      "showInLessDetail": "Mostrar en menos detalle",
      "loadingSpeed": "Velocidad de carga",
      "topContributors": "Principales contribuyentes",
      "showNextFive": "Mostrar los siguientes cinco",
      "commits": "Commit"
    },
    "info": {
      "componentRichTheme": "Tema rico en componentes",
      "completedPullRequests": "Solicitudes de pull completadas",
      "users": "Usuarios",
      "points": "Puntos",
      "units": "Unidades",
      "exploreGallery": "Explorar galería",
      "viewLibrary": "Ver biblioteca",
      "commits": "Commits",
      "components": "Componentes",
      "teamMembers": "Miembros del equipo"
    },
    "tabs": {
      "overview": {
        "title": "Visión general",
        "built": "Construido con el framework Vue.js",
        "free": "Totalmente gratuito para todos",
        "fresh": "Diseño fresco y nítido",
        "mobile": "Adaptable y optimizado para móviles",
        "components": "Toneladas de componentes útiles",
        "nojQuery": "Totalmente libre de jQuery"
      },
      "billingAddress": {
        "title": "Dirección de facturación",
        "personalInfo": "Información personal",
        "firstName": "Nombre y apellido",
        "email": "Correo",
        "address": "Dirección",
        "companyInfo": "Información de la empresa",
        "city": "Ciudad",
        "country": "País",
        "infiniteConnections": "Conexiones infinitas",
        "addConnection": "Añadir conexión"
      },
      "bankDetails": {
        "title": "Detalles del banco",
        "detailsFields": "Campos de detalles",
        "bankName": "Nombre del banco",
        "accountName": "Nombre de la cuenta",
        "sortCode": "Código de ordenación",
        "accountNumber": "Número de cuenta",
        "notes": "Notas",
        "sendDetails": "Enviar detalles"
      }
    },
    "navigationLayout": "Diseño de navegación",
    "topBarButton": "Barra superior",
    "sideBarButton": "Barra lateral"
  },
  "language": {
    "brazilian_portuguese": "Portugués brasileño",
    "english": "Inglés",
    "spanish": "Español",
    "simplified_chinese": "Chino simplificado",
    "persian": "Persa"
  },
  "menu": {
    "auth": "Autenticación",
    "buttons": "Botones",
    "timelines": "Líneas de tiempo",
    "dashboard": "Inicio",
    "billing": "Facturación",
    "login": "Iniciar sesión",
    "preferences": "Preferencias",
    "payments": "Pagos",
    "pricing-plans": "Planes de precios",
    "login-singup": "Iniciar sesión/Registrarse",
    "404": "Páginas 404",
    "faq": "FAQ",
    "users": "Mis Clientes",
    "products": "Mis Productos",
    "invoices": "Facturación",
    "ventas": "Emitir Factura",
    "compras": "Recibir Factura",
    "reports": "Reportes",
    "budgets": "Mis presupuestos",
    "funds": "Fondos",
    "reminders": "Recordatorios",
    "otherInvoices": "Movimientos Financieros",
    "otherIncomings": "Registrar Ingreso",
    "otherOutcomings": "Registrar Egreso",
    "myBusiness": "Mi Negocio",
    "reportsAndAnalysis": "Reportes y Análisis",
    "remindersAndTasks": "Recordatorios y Tareas",
    "taxServices": "Servicios Tributarios"
  },
  "messages": {
    "all": "Ver todos los mensajes",
    "new": "Nuevos mensajes de {name}",
    "mark_as_read": "Marcar como leído",
    "userCreated": "Usuario {name} creado correctamente",
    "userUpdated": "Usuario {name} editado correctamente",
    "userDeleted": "Usuario {name} eliminado correctamente",
    "unsavedChanges": "Tienes cambios sin guardar. ¿Seguro que quieres cerrar el formulario?",
    "error": "Se produjo un error al guardar la información. Verifica los datos ingresados y vuelve a intentarlo. {detail}",
    "errorDeleteUser": "Se produjo un error al eliminar el usuario. Verifica los datos y vuelve a intentarlo.",
    "productCreated": "Producto {name} creado correctamente",
    "productCreateError": "Se produjo un error al crear el producto. {message}",
    "productUpdated": "Producto {name} editado correctamente",
    "productDeleted": "Producto {name} eliminado correctamente",
    "errorDeleteproduct": "Se produjo un error al eliminar el producto. Verifica los datos y vuelve a intentarlo.",
    "invoiceCreated": "Factura creada correctamente",
    "invoiceDeleted": "Eliminado correctamente",
    "errorDeleteInvoice": "Se produjo un error al eliminar la factura",
    "productAlreadyAdded": "Producto seleccionado incorrecto",
    "signatureError": "No pudimos validar tu firma electrónica. Verifícala e intenta de nuevo.",
    "signatureValidMessage": "Firma válida hasta el {date}",
    "signatureInvalidMessage": "Firma vencida el {date}",
    "settingsSuccess": "Configuración guardada correctamente.",
    "settingsError": "Se produjo un error al guardar las configuraciones.",
    "invoiceError": "No se pudo crear la factura: {message}",
    "passwordRules": "La contraseña debe contener al menos 8 caracteres: letras, números y caracteres especiales",
    "requiredField": "{field} es un campo obligatorio",
    "emailRules": "Ingresa un correo válido",
    "repeatPasswordRules": "Las contraseñas no coinciden",
    "password8Characters": "La contraseña debe contener al menos 8 caracteres",
    "password1letter": "La contraseña debe contener al menos una letra",
    "password1Number": "La contraseña debe contener al menos un número",
    "password1Special": "La contraseña debe contener al menos un carácter especial",
    "incorrectLogin": "Usuario o contraseña incorrectos",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "forgotPasswordDescription": "Si olvidaste tu contraseña, no te preocupes. Solamente ingresa tu correo y te enviaremos un acceso temporal para que puedas recuperar tu cuenta.",
    "incorrectInvoiceLoad": "{invoice} no cumple las condiciones. El RUC del comprador ({ruc}) no coincide con el RUC configurado ({rucSettings})",
    "purchasesCreated": "Facturas creadas correctamente",
    "productPriceOptional": "* Pon 0 si quieres cambiar el precio al generar la factura.",
    "noData": "No hay datos disponibles",
    "budgetCreated": "Presupuesto creado correctamente.",
    "budgetDeleteError": "Se produjo un error al eliminar el presupuesto. {message}",
    "budgetDeleted": "Presupuesto eliminado correctamente.",
    "invoiceValidated": "Factura validada correctamente.",
    "errorValidatingInvoice": "Se produjo un error al validar la factura.",
    "reminderCreated": "Recordatorio creado correctamente.",
    "reminderError": "Se produjo un error al crear el recordatorio.",
    "reminderDeleted": "Recordatorio eliminado correctamente.",
    "ingresoDeleted": "Ingreso eliminado correctamente.",
    "ingresoUpdated": "Ingreso modificado correctamente.",
    "ingresoCreated": "Ingreso guardado correctamente.",
    "egresoDeleted": "Egreso eliminado correctamente.",
    "gresoUpdated": "Egreso modificado correctamente.",
    "egresoCreated": "Egreso creado correctamente.",
    "reminderDeleteError": "Se produjo un error al eliminar el recordatorio.",
    "registerSuccess": "Enviamos un enlace de validación a tu correo electrónico.",
    "invoiceSent": "Factura enviada correctamente.",
    "errorSendInvoice": "Se produjo un error al enviar la factura.",
    "reportNoData": "No hay datos para el reporte seleccionado.",
    "maxAllowedDaysReached": "Selecciona un rango de hasta 1 año",
    "atsSameMonth": "El ATS solo admite un rango de fechas dentro del mismo mes.",
    "atsGenerateError": "No se pudo generar el ATS. Verifica el RUC, la razón social y las facturas del período.",
    "atsMissingWorkspaceRuc": "El proyecto activo no tiene un RUC configurado. Configúralo para generar el ATS.",
    "ivaDeclarationError": "No se pudo generar la declaración de IVA.",
    "budgetError": "Se produjo un error al guardar el presupuesto.",
    "noteCreated": "Nota guardada correctamente.",
    "noteError": "Se produjo un error al crear la nota. {message}",
    "noteDeleted": "Nota eliminada correctamente.",
    "noteDeleteError": "Se produjo un error al eliminar la nota. {message}",
    "expiredSignature": "Firma expirada el {date}",
    "sendInvoiceWhatsApp": "Factura enviada correctamente.",
    "errorInvoiceWhatsApp": "Se produjo un error al enviar la factura.",
    "serviceCreated": "Solicitud registrada con éxito. Nos pondremos en contacto contigo pronto.",
    "serviceError": "Se produjo un error al crear la solicitud. {message}",
    "categoryCreated": "Categoría guardada correctamente.",
    "categoryError": "Se produjo un error al crear la categoría. {message}",
    "categoryDeleted": "Categoría eliminada correctamente.",
    "categoryDeleteError": "Se produjo un error al eliminar la categoría. {message}",
    "fileMaxSizeError": "El archivo no puede superar {maxSize}."
  },
  "error": {
    "userNotFound": "Usuario no encontrado",
    "wrongPassword": "Contraseña incorrecta",
    "invalidEmail": "Correo incorrecto",
    "something": "Se produjo algún error, verifica tus datos y vuelve a intentarlo",
    "emailUsed": "Correo ya registrado. Inicia sesión o recupera tu contraseña para continuar",
    "weakPassword": "La contraseña no cumple con los requisitos de seguridad",
    "verificationError": "Código de verificación incorrecto"
  },
  "navbar": {
    "messageUs": "Preguntas sobre desarrollo web:",
    "repository": "Repositorio GitHub"
  },
  "notifications": {
    "all": "Ver todas las notificaciones",
    "mark_as_read": "Marcar como leída",
    "sentMessage": "{name} te envió un mensaje",
    "uploadedZip": "{name} subió un archivo Zip con {type}",
    "startedTopic": "{name} inició un nuevo tema"
  },
  "user": {
    "tax": "Impuestos",
    "language": "Cambiar idioma",
    "logout": "Cerrar sesión",
    "profile": "Mi Perfil",
    "settings": "Configuración",
    "billing": "Facturación",
    "faq": "Preguntas Frecuentes",
    "helpAndSupport": "Ayuda y soporte",
    "projects": "Proyectos",
    "account": "Cuenta",
    "explore": "Explorar"
  },
  "helpAndSupport": "Ayuda y Soporte",
  "aboutVuesticAdmin": "Acerca de Vuestic Admin",
  "search": {
    "placeholder": "Buscar..."
  },
  "users": {
    "add": "Nuevo Cliente",
    "plural": "Clientes",
    "ruc": "Identificación",
    "fullname": "Razón Social",
    "firstName": "Nombres y Apellidos",
    "email": "Correo",
    "address": "Dirección",
    "editUser": "Editar Cliente",
    "deleteTitle": "Eliminar usuario",
    "deleteMessage": "¿Seguro que quieres eliminar al cliente {name}?",
    "identificationType": "Tipo de identificación",
    "phone": "Teléfono"
  },
  "form": {
    "labels": {
      "filterSearch": "Filtrar búsqueda",
      "save": "Guardar",
      "cancel": "Cancelar",
      "results": "Resultados",
      "resultsPerPage": "Resultados por página",
      "delete": "Eliminar",
      "search": "Buscar",
      "userName": "Nombre de usuario",
      "email": "Correo",
      "password": "Contraseña",
      "passwordRepeat": "Confirmar contraseña",
      "sendPassword": "Enviar contraseña",
      "goBack": "Volver",
      "month": "Mes",
      "resetPassword": "Cambiar contraseña",
      "oldPassword": "Contraseña actual",
      "newPassword": "Contraseña nueva",
      "lastLogin": "Último inicio de sesión",
      "downloadReport": "Descargar reporte",
      "actions": "Acciones",
      "sendMessage": "Escribe un mensaje...",
      "syncWhatsapp": "Conecta con WhatsApp",
      "name": "Nombre",
      "lastName": "Apellido",
      "phone": "Celular",
      "chatWhatsapp": "Envía un mensaje por WhatsApp",
      "changePhone": "Cambiar número",
      "sendCode": "Enviar código",
      "verify": "Verificar",
      "send": "Enviar",
      "yes": "Sí",
      "no": "No"
    },
    "placeholder": {
      "selectedYear": "Selecciona un año",
      "selectedMonth": "Selecciona un mes",
      "selectedCategory": "Selecciona una categoría",
      "inputText": "Buscar"
    }
  },
  "products": {
    "plural": "Productos",
    "add": "Nuevo Producto",
    "code": "Código",
    "name": "Nombre",
    "price": "Precio",
    "unit": "Unidad de medida",
    "edit": "Editar producto",
    "deleteTitle": "Eliminar producto",
    "deleteMessage": "¿Seguro que quieres eliminar el producto {name}?",
    "tax": "Tarifa IVA(%)",
    "additionalInfo": "Información adicional",
    "iva": "IVA",
    "unitPrice": "Precio unitario",
    "detail": "Detalle",
    "confirm": "¿Crear nuevo producto {name}?",
    "chooseTax": "Por favor, confirma los datos del producto",
    "stock": "Stock",
    "trackStock": "Manejar stock",
    "movement": "Movimiento de stock"
  },
  "ventas": {
    "plural": "Facturas de Ventas",
    "add": "Nueva Factura",
    "date": "Fecha",
    "client": "Cliente",
    "products": "Productos",
    "code": "Código",
    "total": "Total",
    "subtotal": "Subtotal",
    "tax": "Impuestos",
    "discount": "Descuento",
    "cant": "Cantidad",
    "paymentMethod": "Método de pago",
    "additionalName": "Nombre",
    "additionalDescription": "Descripción",
    "additionalFields": "Campos adicionales",
    "status": "Estado",
    "number": "Número",
    "bulkAdd": "Cargar Facturas Emitidas",
    "isManual": "No generar factura electrónica",
    "generateInvoice": "¿Generar comprobante electrónico para {name}? Se enviará al SRI para validación.",
    "generateComprobante": "¿Guardar comprobante de ingreso?",
    "bulkSave": "¿Guardar comprobantes electrónicos?",
    "subtotalTarifaDiferenteCero": "Subtotal tarifa diferente de 0%",
    "subtotalTarifaCero": "Subtotal tarifa 0%",
    "addIncoming": "Registrar Nuevo Ingreso",
    "deleteComprobante": "¿Eliminar comprobante de ingreso?",
    "category": "Categoría",
    "otherIncomings": "Otros Ingresos",
    "ambiente": "Ambiente",
    "comprobanteNotAllowed": "Factura no permitida",
    "whatTitle": "Enviar por WhatsApp",
    "whatMessage": "¿Seguro que quieres enviarla por WhatsApp?",
    "emailTitle": "Enviar al correo",
    "emailMessage": "¿Seguro que quieres enviarla al correo?",
    "ruc": "Cédula/RUC comprador",
    "label": "Ingresos",
    "creditNote": "Nota de crédito",
    "creditNoteDescription": "Una Nota de Crédito es un comprobante electrónico que sirve para corregir o anular una factura, ajustando valores por devoluciones, descuentos o errores según el SRI.",
    "reason": "Motivo:",
    "datecreditNote": "Fecha de emisión:",
    "generateCreditNote": "Generar Nota de Crédito",
    "when": "¿Cuándo?",
    "paymentMethodUse": "¿Qué método de pago utilizaste?",
    "whatBuy": "¿De qué recibiste el dinero?",
    "howMuch": "¿Cuánto?"
  },
  "settings": {
    "theme": "Color de fondo",
    "dark": "Oscuro",
    "light": "Claro",
    "logo": "Logo emisor",
    "fileUpload": "Carga aquí una imagen del logo de tus comprobantes (máximo 200KB)",
    "signature": "Firma electrónica",
    "signatureUpload": "Carga aquí el archivo en formato .p12 de tu firma electrónica",
    "accountingRequired": "Obligado a llevar contabilidad",
    "other": "Otras configuraciones",
    "passSignature": "Contraseña de la firma electrónica",
    "recepAdded": "URL de recepción",
    "authoAdded": "URL de autorización",
    "environment": "Ambiente",
    "signatureSettings": "Configuraciones de firma electrónica",
    "validateSignature": "Validar firma electrónica",
    "requestSignature": "Solicitar firma electrónica",
    "rimpe": "Contribuyente RIMPE",
    "popular": "Negocio popular",
    "special": "Contribuyente Especial",
    "razon": "Razón Social",
    "commercialName": "Nombre Comercial",
    "ruc": "Cédula/RUC",
    "establecimiento": "Establecimiento",
    "ptoEmision": "Punto de emisión",
    "address": "Dirección matriz",
    "startInvoiceFrom": "Iniciar factura desde",
    "missingSignature": "Solo falta configurar tu RUC/CI para que empieces a emitir y recibir comprobantes de ingresos/egresos.",
    "signatureNotRequired": "Si aún no tienes firma electrónica, configura solo tu información comercial para que puedas registrar comprobantes de ingreso/egreso sin autorización del SRI.",
    "commercialInfo": "Información comercial",
    "missingElectronicSignature": "Configura tu firma electrónica para emitir comprobantes electrónicos.",
    "passwordSRI": "Contraseña SRI",
    "SRISync": "Sincroniza con tu cuenta del SRI",
    "SRIUserError": "No pudimos sincronizar con tu cuenta del SRI. Verifica tus datos y vuelve a intentarlo.",
    "SRIUserNotValid": "Ingresa una cédula o un RUC válidos.",
    "SRIUserValidated": "Cuenta sincronizada correctamente.",
    "synchronized": "Sincronizado correctamente",
    "startCreditNoteFrom": "Iniciar nota de crédito desde"
  },
  "compras": {
    "code": "Código",
    "detail": "Detalle",
    "cant": "Cantidad",
    "price": "Precio",
    "total": "Total",
    "add": "Registrar Nueva Factura",
    "bulkAdd": "Cargar Facturas Recibidas",
    "addXMLFilesMessage": "Carga aquí tus comprobantes en formato XML autorizados por el SRI",
    "cargarArchivos": "Cargar archivos",
    "type": "Tipo comprobante",
    "emisor": "Emisor",
    "direccion": "Dirección",
    "date": "Fecha",
    "deleteMessage": "¿Seguro que quieres eliminar la factura de compra de {emisor}?",
    "tax": "Impuesto",
    "baseImponible": "Base Imponible",
    "documentNumber": "Número de documento",
    "addProduct": "Añadir",
    "subtotalCero": "Subtotal Tarifa 0%",
    "subtotalNoCero": "Subtotal Tarifa Diferente de 0%",
    "discount": "Descuento",
    "details": "Detalles",
    "subtotal": "Subtotal",
    "generateInvoice": "¿Guardar comprobante de compra?",
    "bulkGenerate": "¿Guardar comprobantes de compras?",
    "year": "Año",
    "category": "Categoría",
    "addEgreso": "Registrar Nuevo Egreso",
    "additionalDescription": "Descripción",
    "paymentMethod": "Método de pago",
    "when": "¿Cuándo?",
    "howMuch": "¿Cuánto pagaste?",
    "paymentMethodUse": "¿Qué método de pago utilizaste?",
    "whatBuy": "¿Qué compraste?",
    "deleteComprobante": "¿Eliminar comprobante de egreso?",
    "generateComprobante": "¿Guardar comprobante de egreso?",
    "other": "Otros egresos",
    "secuencial": "Secuencial",
    "label": "Egresos",
    "sriReconcile": "Conciliar SRI",
    "sriReconcileHint": "Carga el reporte Recibidos del SRI (.txt). El mismo archivo sirve para facturas, notas de crédito, notas de débito y retenciones: se identifican por la clave de acceso. Solo se listan los que faltan; súbelos desde Facturas Recibidas.",
    "sriUploadMessage": "Carga aquí el reporte Recibidos del SRI en formato TXT",
    "sriVerify": "Verificar",
    "sriVerifyError": "No se pudo conciliar el reporte SRI.",
    "sriCounts": "Registros (reporte / sistema)",
    "deductible": "Deducible",
    "deductibleInfoTitle": "Gastos deducibles",
    "deductibleInfo": "Un gasto deducible es una compra que puedes usar como crédito tributario de IVA en el Formulario 104. Márcalo solo si tiene relación con tu actividad económica. Si lo marcas, las compras siguientes de este producto también quedarán marcadas.",
    "deductibleError": "No se pudo actualizar el producto deducible.",
    "relatedInvoice": "Factura relacionada",
    "relatedDocuments": "Documentos relacionados",
    "relatedDocumentsEmpty": "Sin documentos relacionados.",
    "sriTotals": "Totales (reporte / sistema)",
    "sriKeys": "Claves de acceso",
    "sriMatch": "Igual",
    "sriMismatch": "No coincide",
    "sriMissing": "Faltan en el sistema",
    "sriMissingShort": "faltantes",
    "sriMissingHint": "Sube estos comprobantes desde Facturas Recibidas.",
    "sriNoMissing": "Todas las claves del reporte ya están en el sistema.",
    "sriMismatched": "Totales distintos",
    "sriExtra": "En el sistema y no en el reporte",
    "sriByType": "Resumen por tipo de comprobante",
    "sriReportCount": "Registros reporte",
    "sriSystemCount": "Registros sistema",
    "sriReportTotal": "Total reporte",
    "sriSystemTotal": "Total sistema",
    "sriAccessKey": "Clave de acceso",
    "sriPeriod": "Período del reporte: {from} a {to}"
  },
  "summary": {
    "ganancia": "Saldo",
    "monthlyEarning": "Ahorro Mensual",
    "invoiceTotal": "Total ingresos",
    "purchaseTotal": "Total gastos",
    "providers": "Resumen de compras por proveedor",
    "totalByProduct": "Resumen de compras por productos",
    "totalRetenciones": "Resumen de retenciones recibidas",
    "totalNotasCredito": "Resumen de notas de crédito recibidas",
    "reportType": "Tipo de reporte",
    "dateFrom": "Fecha desde",
    "dateTo": "Fecha hasta",
    "lastMonth": "Último mes",
    "topProviders": "Proveedores destacados",
    "topEgresos": "Resumen de Egresos por Categoría",
    "topIngresos": "Resumen de Ingresos por Categoría",
    "provider": "Proveedor",
    "total": "Total",
    "yearlyPerformance": "Resumen Anual",
    "topCustomers": "Clientes destacados",
    "topProducts": "Productos más comprados",
    "budget": "Mi Objetivo de Ahorro",
    "invoiceByProvider": "Resumen de ventas por proveedor",
    "invoiceByProduct": "Resumen de ventas por productos",
    "category": "Categoría",
    "gastosPersonales": "Anexo de gastos personales",
    "ats": "ATS (Anexo transaccional simplificado)",
    "ivaMonthly": "Declaración IVA mensual",
    "ivaSemestral": "Declaración IVA semestral",
    "semester": "Semestre"
  },
  "validations": {
    "strBetween": "{field} debe estar entre {min} y {max} caracteres."
  },
  "budgets": {
    "add": "Nuevo presupuesto",
    "total": "Valor",
    "budgetPlan": "Ingresos, gastos, deudas y ahorro del mes.",
    "description": "Nombre",
    "budgetDescription": "Nombre del presupuesto mensual.",
    "year": "Año",
    "month": "Mes",
    "deleteTitle": "¿Eliminar presupuesto?",
    "deleteMessage": "¿Seguro que quieres eliminar el presupuesto {detail}?",
    "current": "Ahorro actual",
    "goal": "Ahorro objetivo",
    "edit": "Editar presupuesto {detail}",
    "monthly": "Mensual",
    "byCategory": "Por categoría"
  },
  "reminders": {
    "add": "Nuevo Recordatorio",
    "date": "¿Cuándo?",
    "description": "¿Qué quieres que te recordemos?",
    "reminderDate": "Ingresa la fecha del recordatorio. Ej. 14/10/2025",
    "reminderDescription": "Ingresa el motivo del recordatorio. Ej. Pago de internet.",
    "deleteTitle": "Eliminar recordatorio",
    "deleteMessage": "¿Seguro que quieres eliminar el recordatorio {detail}?",
    "lastNotifications": "Notificaciones pasadas",
    "currentNotifications": "Notificaciones actuales",
    "update": "Actualizar recordatorio {detail}",
    "reminderHour": "Ingresa la hora del recordatorio. Ej. 09:50",
    "hour": "¿A qué hora?"
  },
  "notes": {
    "add": "Nueva nota",
    "update": "Editar nota - {detail}",
    "title": "Título",
    "description": "Descripción",
    "titleDescription": "Ingresa el título de tu nota. Ej. Último pago de impuestos.",
    "noteDescription": "Ingresa la descripción de tu nota. Ej. Último pago de impuesto a la renta en abril por $150.",
    "date": "Fecha",
    "deleteTitle": "Eliminar nota",
    "deleteMessage": "¿Seguro que quieres eliminar la nota {detail}?"
  },
  "categories": {
    "add": "Nueva categoría",
    "update": "Editar categoría",
    "categoryDescription": "Ingresa el nombre de la categoría. Ej. Gastos hormiga.",
    "categoryDetail": "Ingresa el detalle claro y completo de la categoría. Ej. Gastos pequeños, frecuentes y de bajo monto (cafés, golosinas, snacks rápidos, compras impulsivas).",
    "label": "Categoría",
    "description": "Detalle",
    "deleteTitle": "Eliminar categoría",
    "deleteMessage": "¿Seguro que quieres eliminar la categoría {detail}?",
    "usageInfo": "Estas categorías te ayudan a ordenar tus compras, ver en qué gastas y controlar tus hábitos. Si asignas cada compra a su categoría, vas a tener reportes más claros y podrás decidir mejor con SpendFit.",
    "usageIngresoInfo": "Estas categorías te ayudan a ordenar tus ingresos y ver de dónde llega tu dinero. Si asignas cada ingreso a su categoría, vas a tener reportes más claros y podrás decidir mejor con SpendFit."
  }
}
